<template>
  <v-dialog persistent v-model="open" max-width="480px">
    <v-card class="content-container">
      <v-card-title class="title pt-4 pb-1">
        {{ $t('selectEntity.selectEntityToView') }}
      </v-card-title>

      <template v-if="viewableEntities.length === 0">
        <v-layout class="pa-3 body-1 text-xs-left">
          <span style="font-size: 15px"
            >This account does not have active entities to view. Please contact
            your firm.</span
          >
        </v-layout>
      </template>

      <template v-else>
        <v-alert
          outline
          color="primary"
          :value="true"
          class="text-xs-left"
          icon="info"
        >
          {{ $t('selectEntity.selectEntityToViewMessage') }}
        </v-alert>

        <v-list class="mt-2" one-line>
          <v-list-tile
            v-for="entity in viewableEntities"
            :key="entity.id"
            @click="selectEntity(entity)"
            avatar
            class="py-1"
          >
            <v-list-tile-content>
              <v-list-tile-title
                v-text="entity.tax_return_name"
              ></v-list-tile-title>
              <v-list-tile-sub-title
                v-text="entity.entity_type"
              ></v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-icon>chevron_right</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import API from '@/api';

export default {
  name: 'SelectEntity',
  data() {
    return {
      open: true,
    };
  },
  computed: {
    ...mapState('companies', ['companies']),
    ...mapGetters({
      currentUser: 'user',
    }),

    viewableEntities() {
      return this.companies.filter(c => !c.inactive);
    },
  },
  methods: {
    async selectEntity(company) {
      await this.$store.dispatch('setDefaultCompany', {
        companyId: company.id,
      });

      await this.$store.dispatch('resetTiles', { companyId: company.id });

      const redirectPath = this.$route.query.redirect;

      if (redirectPath) {
        this.$router.push(redirectPath);
      } else {
        this.$router.push('/');
      }
    },

    isPersonal(entity_type) {
      return entity_type === 'Individual';
    },
  },
};
</script>

<style scoped lang="postcss">
.v-toolbar {
  background-color: #46535c;
}
.content-container {
}
.title {
  font-weight: 700;
}
</style>
